import React, { useEffect } from "react";
import { useTranslation, Trans } from "@ca-dmv-radv/translation";
import { RadioGroup, RadioItem, Icon } from "@ca-dmv/core";
import { APPLICATION_TYPE, postOptedCategory } from "@ca-dmv-radv/data";
import SignatureExample from "../SignatureExample";

export default function OptionalDocumentPrompt({
  applicationType,
  proofOfDocumentCategory,
  setWillUpload,
  optedIn,
}) {
  const { t } = useTranslation();

  let signatureMessage;
  let signatureMessage2;
  if (optedIn === true) {
    signatureMessage = t(
      `${applicationType}-screens-category${proofOfDocumentCategory.categoryId}-optionalYesMessage`,
      `How to Provide Your Signature`
    );
    signatureMessage2 = t(
      `${applicationType}-screens-category${proofOfDocumentCategory.categoryId}-optionalYesMessage-ext`,
      `Sign a plain white piece of paper using blue or black ink. Keep it clear, straight, and fully visible.`
    );
  } else {
    signatureMessage = t(
      `${applicationType}-screens-category${proofOfDocumentCategory.categoryId}-optionalNoMessage`,
      `You have chosen to not upload a ${proofOfDocumentCategory.categoryName} document.`
    );
  }
  const legendClass =
    applicationType === APPLICATION_TYPE.CEC
      ? "text--blue-dark-2 text--700 text--md"
      : "text--sm text--h5";

  const handleDescision = async (decision) => {
    if (applicationType !== APPLICATION_TYPE.CEC)
      await postOptedCategory(
        applicationType,
        proofOfDocumentCategory.categoryId,
        decision
      );
    setWillUpload(decision);
  };

  // Default to document upload option for CEC
  useEffect(() => {
    if (applicationType === APPLICATION_TYPE.CEC) {
      setWillUpload(true);
    }
  }, []);

  return (
    <>
      <RadioGroup
        legend={t(
          `${applicationType}-category${proofOfDocumentCategory.categoryId}-optional-prompt`,
          `Would you like to upload ${proofOfDocumentCategory.categoryName} documents?`
        )}
        containerClass="mb-8"
        legendClass={legendClass}
      >
        <RadioItem
          containerClass="mb-8"
          label={t(
            `${applicationType}-category${proofOfDocumentCategory.categoryId}-optionalUpload-yes`,
            "Yes"
          )}
          onChange={async () => await handleDescision(true)}
          required={false}
          checked={optedIn === true}
        />
        <RadioItem
          containerClass="mb-8"
          label={t(
            `${applicationType}-category${proofOfDocumentCategory.categoryId}-optionalUpload-no`,
            "No"
          )}
          onChange={async () => await handleDescision(false)}
          required={false}
          checked={optedIn === false}
        />
      </RadioGroup>
      {/* If opted to update signature display instruction */}
      {optedIn && applicationType !== APPLICATION_TYPE.CEC && (
        <>
          <p className="text--h3 text--sm text--primary text--tighten bp-md:text--left">
            <Trans>{signatureMessage}</Trans>
          </p>
          <p className="text--xxsm text--tighten text--blue-dark-2 mb-16">
            <Trans>{signatureMessage2}</Trans>
          </p>
          <SignatureExample />
        </>
      )}
      {optedIn === false && applicationType !== APPLICATION_TYPE.CEC && (
        <div className="show--flex">
          <Icon icon="check" className="mr-8 mt-5 min-width--15" />
          <p className="text--sm text--blue-dark-2 mb-16">
            <Trans>{signatureMessage}</Trans>
          </p>
        </div>
      )}
    </>
  );
}
